import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation DeleteAgentChatConversation(
    $tenantId: ID!
    $zoneId: ID!
    $conversationId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        deleteAgentChatConversation(conversationId: $conversationId)
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.DeleteAgentChatConversationMutation,
  undefined,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'deleteAgentChatConversation',
      graphql.transformers.OUT.always(undefined),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.DeleteAgentChatConversationMutation,
  undefined,
  graphql.schema.DeleteAgentChatConversationMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
